<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<section aria-describedby="fk-modal-content"
         aria-labelledby="fk-modal-heading"
         aria-modal="true"
         class="slds-modal slds-fade-in-open slds-modal_medium"
         role="dialog"
         tabindex="-1">
  <div class="slds-modal__container">
    <header class="slds-modal__header">
      <button (click)="onClose()"
              class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse"
              title="Close">
        <svg aria-hidden="true" class="slds-button__icon slds-button__icon_large">
          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
        </svg>
        <span class="slds-assistive-text">Close</span>
      </button>
      <h2 class="slds-text-heading_medium slds-hyphenate"
          id="fk-modal-heading">Select {{label}}</h2>

      <div class="slds-grid slds-grid_align-center slds-m-top_small">
        <div class="slds-form-element">
          <div class="slds-form-element__control">
            <input #searchTerm (keyup)="onSearchKeyUp($event)"
                   autofocus
                   class="slds-input"
                   id="fk-search"
                   placeholder="Enter Search"
                   autocomplete="off"
                   title="enter search term - ESC clears - UP/DOWN changes - TAB/ENTER picks first or searchs"
                   type="search"/>
          </div>
        </div>
        <button (click)="onSearch()"
                class="slds-button slds-button_neutral slds-m-left_small">Search
        </button>
        <div class="slds-m-left_small" style="line-height: 2rem;">
          <small class="slds-truncate">{{info}}</small>
        </div>
      </div>
    </header>

    <div class="slds-modal__content slds-p-around_medium slds-is-relative"
         id="fk-modal-content"
         style="min-height: 300px;">

      <table class="slds-table slds-table_cell-buffer slds-table_bordered">
        <thead>
        <tr class="slds-line-height_reset">
          <th class="" scope="col">
            <div class="slds-truncate" title="Name">Option</div>
          </th>
        </tr>
        </thead>

        <tbody>
        <tr #fktr
            *ngFor="let op of options"
            (click)="onSelect(op)"
            [attr.aria-selected]="op.isSelected"
            [class.slds-hide]="touched && !op.isMatched"
            [class.slds-is-selected]="op.isSelected"
            class="slds-hint-parent">
          <td data-label="Option">
            <div [innerHTML]="op.display"></div>
          </td>
        </tr>
        </tbody>

      </table>

      <acc-spinner *ngIf="busy"></acc-spinner>
    </div>

    <footer class="slds-modal__footer slds-modal__footer_directional">
      <button (click)="onCancel()"
              class="slds-button slds-button_neutral"
              title="Clear selection and close">Clear
      </button>
      <acc-status-line [error]="error"
                       [message]="message"
                       style="display: inline-block; margin: 0 1em;"></acc-status-line>
      <button [disabled]="selectDisabled"
              (click)="onClickSelect()"
              class="slds-button slds-button_brand"
              title="Select first (matched) option">Select
      </button>
    </footer>
  </div>
</section>
<div class="slds-backdrop slds-backdrop_open"></div>
